import React, { useContext, useEffect, useState } from "react";
import css from "../css/Mywallet.module.css";
import Rightcontainer from "../Components/Rightcontainer";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import socket from "../Components/socket";
import { AiOutlineHistory, AiOutlinePlus } from "react-icons/ai";
import { BsWallet2 } from "react-icons/bs";
import io from "../Components/socket";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { VscReferences } from "react-icons/vsc";
import Swal from "sweetalert2";

const Mywallet = ({ user }) => {
  // const [user, setUser] = useState();

  const access_token = localStorage.getItem("token");
  //   const walletUpdate =()=>{
  //  io.emit("getprofile", access_token);
  //   io.on("setProfile", (data) => {
  //     setUser(data);
  //   });
  //   }

  //   useEffect(()=>{
  //     walletUpdate()
  //   },[]);

  // language

  const userData = localStorage.getItem("udata");
  const udata = JSON.parse(userData);
  const translations = {
    hi: {
      wallet: "वॉलेट",
      history: "इतिहास देखे | ",
      amount: "पैसे जोड़ें | ",
      withdraw: "पैसे निकाले  | ",
      referPerson: "रेफ़रल | ",
    },
    en: {
      wallet: "My Wallet",
      history: "Order History",
      amount: "Add Cash",
      withdraw: "Withdraw",
      referPerson: "Referral",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const theme = localStorage.getItem("theme");

  const styles = {
    backgroundColor: theme === "light" ? "#fffff0" : "#000",
    color: theme === "light" ? "black" : "#fff",
  };

  return (
    <>
      <div
        className="leftContainer mb_space"
        style={{ ...styles, height: "100vh" }}
      >
        <div className="pt-2 mt-5  Orher_page_main_section">
          {/* <div className="main_heading_with_btn mb-3">
            <h2 className="profile_headings" style={styles}>{translations[language].wallet}</h2>
            <Link className="profile_wallet" to="/history">
              <AiOutlineHistory className="icons" /> {translations[language].history}
            </Link>
          </div> */}

          {/* <div style={{ width: "fit-content", marginTop: "10px" }}>
            <a
              href="https://youtu.be/-OocN0l02_s?si=x0enTSJVqedu5NN0"
              target="_blank"
            >
              <span
                className="d-flex align-items-center  btn-md guide_btn"
                style={{
                  right: "0.5rem",
                  backgroundColor: "#003441",
                  color: "white",
                  borderRadius: "4px",
                  padding: "4px 13px",
                  fontSize: "12px",
                }}
              >
                Youtube
                <img
                  className="ml-2"
                  src={"/images/Homepage/youtube.png"}
                  alt=""
                  width="15px"
                />
              </span>
            </a>
          </div> */}

          {/* <div className='main_area'>
            <div
              className='p-4 bg-light'
              style={{ border: '1px solid #e0e0e0', borderRadius: '5px' }}
            >
              <Link
                className={`d-flex align-items-center ${css.profile_wallet} undefined`}
                to='/transaction-history'
              >
                <picture className='ml-4'>
                  <img
                    width='32px'
                    src={
                      process.env.PUBLIC_URL +
                      '/images/Header/order-history.png'
                    }
                    alt=''
                  />
                </picture>
                <div className={`ml-5 ${css.mytext} text-muted `}>
                  Order History
                </div>
              </Link>
            </div>
          </div> */}
          <div className="mt-2">
            <h3 className="mb-3">Balance</h3>

            {/* ================= DEPOSIT CASH CARD (Green Theme) ================= */}
            <div className="wallet_page_cards deposit-card">
              <div className="card-content">
                {/* Left Side: Icon & Balance */}
                <div className="d-flex align-items-center">
                  {/* <div className="icon-container deposit-bg">
          <img className="icon-img" src="/deposit-case.png" alt="Deposit" />
        </div> */}

                  <div className="text-container ml-3">
                    <span className="label-text">Deposit Cash</span>
                    <div className="amount-wrapper">
                      <img
                        src="/images/rupee.png"
                        alt="₹"
                        className="rupee-icon"
                      />
                      {/* Calculation Logic Preserved */}
                      <span className="amount-text text-green">
                        {user && user.Wallet_balance - user.withdrawAmount}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Right Side: Button */}
                <div>
                  <Link
                    to="/addcase"
                    className="text-decoration-none"
                    onClick={(e) => {
                      if (udata?.verified === "unverified") {
                        e.preventDefault();
                        Swal.fire({
                          icon: "warning",
                          title: "Please complete KYC",
                          text: "You need to complete your KYC before proceeding.",
                          confirmButtonText: "OK",
                        });
                      }
                    }}
                  >
                    <button className="add-cash-btn">
                      <AiOutlinePlus className="btn-icon" />
                      <span>{translations[language].amount}</span>
                    </button>
                  </Link>
                </div>
              </div>

              {/* Footer Note */}
              <div className="card-footer-note">
                <p>
                  Can be used to play Tournaments & Battles. Cannot be withdrawn
                  to Paytm or Bank.
                </p>
              </div>
            </div>

            {/* ================= WINNING CASH CARD (Red Theme - Already Done) ================= */}
            <div className="wallet_page_cards winning-card">
              <div className="card-content">
                <div className="d-flex align-items-center">
                  {/* <div className="icon-container winning-bg">
                    <img
                      className="icon-img"
                      src="/winning-cash.png"
                      alt="Winning"
                    />
                  </div> */}
                  <div className="text-container ml-3">
                    <span className="label-text">Winning Cash</span>
                    <div className="amount-wrapper">
                      <img
                        src="/images/rupee.png"
                        alt="₹"
                        className="rupee-icon"
                      />
                      <span className="amount-text text-red">
                        {user && user.withdrawAmount ? user.withdrawAmount : 0}
                      </span>
                    </div>
                  </div>
                </div>
                <div>
                  <Link to="/Withdrawopt" className="text-decoration-none">
                    <button className="withdraw-btn">
                      <BsWallet2 className="btn-icon" />
                      <span>{translations[language].withdraw}</span>
                    </button>
                  </Link>
                </div>
              </div>
              <div className="card-footer-note">
                <p>
                  Can be withdrawn to Paytm or Bank. Can be used to play
                  Tournaments & Battles.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="rightContainer">
          <div>
            <Rightcontainer />
          </div>
        </div>
      </div>
    </>
  );
};
export default Mywallet;
